// extracted by mini-css-extract-plugin
module.exports = {"article-feature":"article-feature","text-body":"text-body","dh-psy-example":"dh-psy-example"};